<div class="p-3 rounded-3">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/Dashboard-icon.png" alt="Dashboad" onkeydown="" />
        </div>
        <h3>{{ "Dashboard" }}</h3>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <!-- Active Users -->
        <div class="card">
          <div class="d-flex justify-content-between align-items-center p-3">
            <h6 class="heading">Clients Count</h6>
          </div>
          <div class="container plans">
            <div class="container-fluid">
              <div class="row">
                <!-- Active Clients -->
                <div class="col-xl-6 col-lg-6 col-md-6">
                  <div class="card card-pricing text-center shadow" style="height: 200px;">
                    <span class="h6 w-60 mx-auto px-4 py-1 rounded-bottom shadow-sm head active">
                      Active Clients
                    </span>
                    <div class="card-body pt-3">
                      <p class="count-text">Active Clients: <strong>{{ clientsCounts?.ActiveCount }}</strong></p>
                    </div>
                  </div>
                </div>

                <!-- Non-Active Clients -->
                <div class="col-xl-6  col-lg-6 col-md-6">
                  <div class="card card-pricing text-center shadow" style="height: 200px;">
                    <span class="h6 w-60 mx-auto px-4 py-1 rounded-bottom shadow-sm head inactive">
                      Non-Active Clients
                    </span>
                    <div class="card-body pt-3">
                      <p class="count-text">Non-Active Clients: <strong>{{ clientsCounts?.NonActiveCount }}</strong></p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Total Clients -->

              <div class="row mt-4">
                <div class="col-xl-6 col-lg-6 col-md-6">
                  <div class="card card-pricing text-center shadow" style="height: 200px;">
                    <span class="h6 w-60 mx-auto px-4 py-1 rounded-bottom shadow-sm head total">
                      Total Clients
                    </span>
                    <div class="card-body pt-3">
                      <p class="count-text">Total Clients: <strong>{{ clientsCounts?.TotalCount }}</strong></p>
                    </div>
                  </div>
                </div>

                <!-- Total Paid Clients -->
                <div class="col-xl-6 col-lg-6 col-md-6">
                  <div class="card card-pricing text-center shadow" style="height: 200px;">
                    <span class="h6 w-60 mx-auto px-4 py-1 rounded-bottom shadow-sm head paid">
                      Total Paid Clients
                    </span>
                    <div class="card-body pt-3">
                      <p class="count-text">Total Paid Clients: <strong>{{ clientsCounts?.PaidClient }}</strong></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="d-flex justify-content-between align-items-center p-3">
            <h6 class="heading">Active Clients Year wise</h6>
            <div class="toogleBtn">
              <mat-form-field class="mat-datepicker mb-0">
                <input matInput [matDatepicker]="dp" placeholder="Year" [formControl]="date">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event, dp)"
                  panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <!--Kendo Graph-->
          <div class="container" style="height:475px">
            <kendo-chart>
              <kendo-chart-legend position="top"></kendo-chart-legend>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item *ngFor="let item of valueAxes" [min]="item.min" [max]="item.max"
                  [title]="{ text: 'Clients', color: '#044b4f' }">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="categories" [axisCrossingValue]="crossingValues"
                  [title]="{ text: 'Months', color: '#044b4f' }">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-series>
                <kendo-chart-series-item *ngFor="let item of series1" [color]="item.color" [data]="seriesData">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-category="category" let-dataItem="dataItem">
                      Client ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
                <kendo-chart-series-item *ngFor="let item of series2" [color]="item.color" [data]="seriesData2">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-category="category" let-dataItem="dataItem">
                      Patient ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
                <kendo-chart-series-item *ngFor="let item of series3" [color]="item.color" [data]="seriesData3">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-category="category" let-dataItem="dataItem">
                      Appointment ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="d-flex justify-content-between align-items-center p-3">
            <h6 class="heading">Device Type Count</h6>
          </div>
          <div class="container device-chart">
            <kendo-chart>
              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
              <kendo-chart-tooltip [shared]="true"></kendo-chart-tooltip>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [title]="{ text: 'Count', color: '#044b4f' }">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="deviceTypeCategories"
                  [title]="{ text: 'Device Type', color: '#044b4f' }">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-series>
                <kendo-chart-series-item type="column" color="#044b4f" [data]="deviceTypeSeriesData">
                  <kendo-chart-series-item-labels [visible]="true" format="{0}">
                  </kendo-chart-series-item-labels>
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-category="category" let-dataItem="dataItem">
                      {{category}} ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>